module.exports = __webpack_public_path__ + "img/crane3.6540accf.png";